export default {
	methods: {
		closeWizard() {
			this.$emit('close-wizard');
		},
		workflowCreated(newWorkflow) {
			this.$emit('workflow-created', newWorkflow);
		},
		sendStartCreationProcessMessage(creationProcessMessage) {
			this.$emit('start-creation-process', creationProcessMessage);
		},
	},
};
